import * as React from "react";
import { UitkLoader } from "uitk-react-loader";

interface LoaderProps {
  loading: boolean;
}

export function Loader({ loading }: LoaderProps) {
  return loading ? (
    <div className="loaderContainer uitk-grid all-grid-align-middle all-grid-align-center">
      <UitkLoader />
    </div>
  ) : null;
}

export default Loader;
